import React, { useEffect, useState, FC, useCallback, useMemo } from 'react'         // โหลด locale ไทย

const JackpotWidget = () => {
    const [currentAmount, setCurrentAmount] = useState(1000000);
    const [displayAmount, setDisplayAmount] = useState(1000000);

    // Constants
    const START_DATE = useMemo(() => {
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth(); // 0-11
        const currentDate = now.getDate();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();

        // กำหนดเวลาปัจจุบันในมิลลิวินาที
        const currentTime = now.getTime();

        // สร้างวันที่ 1, 7, 21 ของเดือนปัจจุบัน
        const date1 = new Date(currentYear, currentMonth, 1, 0, 0, 0);
        const date7 = new Date(currentYear, currentMonth, 7, 0, 0, 0);
        const date21 = new Date(currentYear, currentMonth, 21, 0, 0, 0);

        // สร้างเวลา 00:01 ของแต่ละวัน
        const date1Plus1Min = new Date(currentYear, currentMonth, 1, 0, 1, 0);
        const date7Plus1Min = new Date(currentYear, currentMonth, 7, 0, 1, 0);
        const date21Plus1Min = new Date(currentYear, currentMonth, 21, 0, 1, 0);

        if (currentTime >= date21Plus1Min.getTime()) {
            // ถ้าเวลาปัจจุบัน >= วันที่ 21 เวลา 00:01 ให้ใช้วันที่ 21
            return date21;
        } else if (currentTime >= date7Plus1Min.getTime()) {
            // ถ้าเวลาปัจจุบัน >= วันที่ 7 เวลา 00:01 ให้ใช้วันที่ 7
            return date7;
        } else if (currentTime >= date1Plus1Min.getTime()) {
            // ถ้าเวลาปัจจุบัน >= วันที่ 1 เวลา 00:01 ให้ใช้วันที่ 1
            return date1;
        } else {
            // ถ้ายังไม่ถึงวันที่ 1 เวลา 00:01 ให้ใช้วันที่ 21 ของเดือนก่อนหน้า
            const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
            const prevYear = currentMonth === 0 ? currentYear - 1 : currentYear;
            return new Date(prevYear, prevMonth, 21, 0, 0, 0);
        }
    }, []);
    const BASE_AMOUNT = 0;
    const PER_SECOND_INCREASE = 10;

    // Calculate current jackpot based on time
    const calculateCurrentJackpot = useCallback(() => {
        const now = new Date();
        const timeDiff = now.getTime() - START_DATE.getTime();
        const secondsPassed = timeDiff / 1000; // แปลงเป็นวินาที

        const additionalAmount = secondsPassed * PER_SECOND_INCREASE;
        return Math.floor(BASE_AMOUNT + additionalAmount);
    }, [START_DATE, BASE_AMOUNT, PER_SECOND_INCREASE]);

    // Get random update interval (1-3 seconds)
    const getRandomUpdateInterval = () => {
        return Math.random() * 4000 + 1000; // สุ่มระหว่าง 1000-5000 มิลลิวินาที (1-5 วินาที)
    };

    // Animate number counter
    const animateToAmount = useCallback((targetAmount) => {
        const startAmount = displayAmount;
        const difference = targetAmount - startAmount;
        const duration = 800; // 0.8 วินาที
        const startTime = Date.now();

        const animate = () => {
            const now = Date.now();
            const progress = Math.min((now - startTime) / duration, 1);

            // Easing function (ease-out)
            const easeOut = 1 - Math.pow(1 - progress, 3);
            const currentValue = startAmount + (difference * easeOut);

            setDisplayAmount(Math.floor(currentValue));

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                setDisplayAmount(targetAmount);
            }
        };

        requestAnimationFrame(animate);
    }, [displayAmount]);

    // Update jackpot amount
    const updateJackpot = useCallback(() => {
        const newAmount = calculateCurrentJackpot();
        setCurrentAmount(newAmount);
        animateToAmount(newAmount);
    }, [calculateCurrentJackpot, animateToAmount]);

    // Schedule next update with random interval
    const scheduleNextUpdate = useCallback(() => {
        const interval = getRandomUpdateInterval();

        const timeoutId = setTimeout(() => {
            updateJackpot();
            scheduleNextUpdate();
        }, interval);

        return timeoutId;
    }, [updateJackpot]);

    // Initialize jackpot on component mount
    useEffect(() => {
        // Set initial amount
        const initialAmount = calculateCurrentJackpot();
        setCurrentAmount(initialAmount);
        setDisplayAmount(initialAmount);

        // Start regular updates every second
        const timeoutId = scheduleNextUpdate();

        // Cleanup timeout on unmount
        return () => {
            clearTimeout(timeoutId);
        };
    }, [calculateCurrentJackpot, scheduleNextUpdate]);

    // Format amount with Thai locale
    const formatAmount = (amount: number) => {
        return amount.toLocaleString('th-TH');
    };

    return (
        <div className='jackpot-container-two'>
            <img className="jackpot-image-two" src='/widget/jackpot-three.gif' alt='jackpot' />
            <div className='jackpot-amount text-gradient'>
                <span className='currency'>฿</span>
                <span>{formatAmount(currentAmount)}</span>
            </div>
        </div>
    );
}

export default JackpotWidget
